import React, { Component } from 'react'

import './dog-placeholder.styl'

export default class DogPlaceholder extends Component {
  render(): JSX.Element {
    return <div className="dog-placeholder" />
  }
}
